import React from 'react';

function BigTriangle() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='660.281'
      height='717.557'
      viewBox='0 0 660.281 717.557'
    >
      <path
        fill='#5c6ef8'
        d='M288.511 22.489a15 15 0 0125.978 0L590 499.5a15 15 0 01-12.986 22.5H25.986A15 15 0 0113 499.5z'
        data-name='Polygon 83'
        transform='rotate(105.01 278.283 320.83)'
      ></path>
    </svg>
  );
}

export default BigTriangle;
